/*

Actual broadcasting of a MediaStream to a given file/uri

*/
import useWebRTCBroadcaster from "../../../hooks/MediaOutput/WebRTCBroadcaster";

const WebRTCOutput = (props) => {
  useWebRTCBroadcaster({
    uri: props.target,
    stream: props.mediaRef,
    streamBitrate: props.streamBitrate,
  });
};

export default WebRTCOutput;
